



















import Vue, { PropType } from 'vue';

const themeType = ['primary', 'error', 'primary-outline', 'sub'];
const sizeType = ['small', 'large'];

export default Vue.extend({
  name: 'GBaseButton',
  props: {
    theme: {
      type: String as PropType<string>,
      validator: (prop: string) => themeType.includes(prop),
      default: 'primary',
    },
    size: {
      type: String as PropType<string>,
      validator: (prop: string) => sizeType.includes(prop),
      default: 'small',
    },
    disabled: {
      type: Boolean as PropType<boolean>,
      default: false,
    },
  },
  methods: {
    onClick(): void {
      this.$emit('click');
    },
  },
});
